// import React, { useState } from 'react'
// import purchaseService from '../../Services/purchaseService';
// import {useNavigate} from "react-router-dom";
// import toast from 'react-hot-toast';

// const DiscountModal = ({ open, onClose, purchaseId }) => {
//     const [discount, setDiscount] = useState(0);
//     const [loading, setLoading] = useState(false);

//     const navigate = useNavigate()

//     const handleDiscountChange = (e) => {
//       setDiscount(e.target.value);
//     };

//     const handleSubmit = () => {
//         const approve = async () => {
//             setLoading(true);
//             if (discount >= 0) {
//                 const response = await purchaseService.approvePurchase(purchaseId, discount);
//                 if (response.responseCode === 200) {
//                     navigate('/admin/pharmacy/purchases')
//                 }
//             } else {
//                 toast.error("Please Enter Amount 0 or Greater")
//             }
//         }
//         approve();
//         onClose();
//       }

//     return (
//       <div
//         className={`fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50 ${!open ? 'hidden' : ''}`}
//       >
//         <div className="bg-white p-6 rounded-lg w-[300px]">
//           <h2 className="text-xl font-semibold mb-4">Enter Discount</h2>
//           <input
//             type="number"
//             placeholder="Discount Amount"
//             value={discount}
//             onChange={handleDiscountChange}
//             className="w-full p-2 border border-gray-300 rounded-md mb-4"
//           />
//           <div className="flex justify-between">
//             <button
//               onClick={onClose}
//               className="bg-gray-300 px-4 py-2 rounded-md"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSubmit}
//               className="bg-green-500 text-white px-4 py-2 rounded-md"
//             >
//               Approve
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   export default DiscountModal;

import React, { useState } from "react";
import purchaseService from "../../Services/purchaseService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const DiscountModal = ({ open, onClose, purchaseId }) => {
  const [discount, setDiscount] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleDiscountChange = (e) => {
    setDiscount(e.target.value);
  };

  const handleSubmit = () => {
    const approve = async () => {
      setLoading(true);
      if (discount >= 0) {
        const response = await purchaseService.approvePurchase(
          purchaseId,
          discount,
        );
        if (response.responseCode === 200) {
          navigate("/admin/pharmacy/purchases");
        }
      } else {
        toast.error("Please Enter Amount 0 or Greater");
      }
    };
    approve();
    onClose();
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-[340px] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="bg-[#1F2937] px-5 py-4 flex items-center justify-between flex-shrink-0">
          <div>
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Purchase Approval
            </p>
            <p className="text-white font-semibold text-sm leading-tight mt-0.5">
              Enter Discount
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* ── Body ── */}
        <div className="px-5 py-5">
          {/* Purchase ID badge */}
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              P
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-700">Purchase ID</p>
              <p className="text-[11px] text-gray-400">
                #{purchaseId || "N/A"}
              </p>
            </div>
            <span className="ml-auto text-[10px] font-semibold px-2.5 py-1 rounded-full bg-amber-50 text-amber-600 border border-amber-100 whitespace-nowrap">
              Pending
            </span>
          </div>

          {/* Input */}
          <label className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1.5 block">
            Discount Amount
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={discount}
            onChange={handleDiscountChange}
            className="w-full px-3 py-2.5 border border-gray-200 bg-gray-50 rounded-xl text-sm text-gray-700
              focus:outline-none focus:ring-2 focus:ring-gray-300 focus:bg-white transition-all"
          />
          <p className="text-[10px] text-gray-400 mt-1.5">
            Enter 0 to approve without discount.
          </p>
        </div>

        {/* ── Footer ── */}
        <div className="border-t border-gray-100 bg-gray-50 px-5 py-3 flex items-center justify-end gap-2 flex-shrink-0">
          <button
            onClick={onClose}
            className="text-[11px] font-semibold px-4 py-1.5 rounded-lg bg-gray-100 text-gray-600
              hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="text-[11px] font-semibold px-4 py-1.5 rounded-lg bg-green-600 text-white
              hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5"
          >
            {loading ? (
              <>
                <svg
                  className="w-3 h-3 animate-spin"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8z"
                  />
                </svg>
                Processing...
              </>
            ) : (
              <>
                <svg
                  className="w-3 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Approve
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscountModal;
